import { supabase } from '../config/supabase';

const CACHE_TTL = 5 * 60 * 1000; // 5 minuti

const deezerCache = new Map();

const buildCacheKey = (query, limit) => `${query?.toLowerCase() || ''}-${limit}`;

/** Chiama Deezer tramite la nostra Edge Function (niente CORS, niente limiti proxy pubblici) */
const fetchViaEdgeFunction = async (query, limit) => {
    const { data, error } = await supabase.functions.invoke('deezer-proxy', {
        body: { query: String(query).trim(), limit: Math.min(Math.max(Number(limit) || 25, 1), 50) }
    });
    if (error) throw error;
    if (data && typeof data.data !== 'undefined') return data;
    return { data: [] };
};

export const searchDeezerTracks = async (query, limit = 25) => {
    if (!query) {
        return { data: [] };
    }

    const cacheKey = buildCacheKey(query, limit);
    const cachedEntry = deezerCache.get(cacheKey);
    if (cachedEntry && Date.now() - cachedEntry.timestamp < CACHE_TTL) {
        return cachedEntry.data;
    }

    let data = { data: [] };
    try {
        data = await fetchViaEdgeFunction(query, limit);
    } catch (e) {
        console.warn('[Deezer] Edge Function non disponibile o errore, anteprime non disponibili.', e?.message || e);
    }

    deezerCache.set(cacheKey, {
        data,
        timestamp: Date.now()
    });

    return data;
};

